import React from 'react';
import {useTranslation} from 'react-i18next';
import cx from 'classnames';

import {Text, Button, FontVariant} from '@pexip/components';

import type {RoomID} from '../../types';

import styles from './BreakoutRoomsAskingForHelpRoomRow.module.scss';
import {TestId} from '../../../test/testIds';

export const BreakoutRoomsAskingForHelpRoomRow: React.FC<{
    breakoutName: string;
    roomId: RoomID;
    onJoinRoom: (roomId: RoomID) => void;
    className?: string;
}> = ({breakoutName, roomId, onJoinRoom, className}) => {
    const {t} = useTranslation();

    return (
        <div className={cx(styles.roomRow, className)}>
            <div className={styles.room}>
                <Text
                    fontVariant={FontVariant.Body}
                    isTruncated
                    title={breakoutName}
                    translate="no"
                >
                    {breakoutName}
                </Text>
            </div>
            <Button
                data-testid={TestId.ButtonBreakoutJoinAskingForHelp}
                size="small"
                className="mr-2 ml-2"
                variant="success"
                aria-label={t(
                    'common.join-breakout-room-aria-label',
                    'Join breakout room',
                )}
                onClick={() => onJoinRoom(roomId)}
            >
                {t('common.join', 'Join')}
            </Button>
        </div>
    );
};

export type BreakoutRoomsAskingForHelpRoomRowProps = React.ComponentProps<
    typeof BreakoutRoomsAskingForHelpRoomRow
>;
